import { Box, TextField } from '@mui/material'
import React, { memo, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useForm } from 'hooks/useForm'
import { useSearch } from 'hooks/useSearch';
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { getCustomersCoincidences } from './GetCustomerCoincidences';
import { FormCustomerSelectRuleEdit } from './FormCustomerSelectRuleEdit';

export const FormOneCustomerNameRuleEdit = memo((props) => {
  const { setNames, setValidatedNames, names, name, validatedNames, idStation } = props
  const { setSnackbar } = useSearch();
  const { deleteMode } = useSelector(state => state.contractsCatalog)
  const { inputValues, handleInputOnChange, cleanForm } = useForm({ nameInput: name.name })
  const { nameInput } = inputValues

  const handleSearch = async(e) => {
    e.preventDefault();
    e.stopPropagation()
    const isOnList = names.filter(item => item.name === nameInput && item.id !== name.id).length !== 0
    if (nameInput.length === 0) {
      setSnackbar( "Por favor introduce un nombre", "warning" )
      return;
    }
    if (nameInput.length < 4 || nameInput.length > 250) {
      setSnackbar( "El el nombre debe de tener una logitud minima de 4 caracteres", "warning" )
      return;
    }
    const isValidated = validatedNames.filter(vName => vName.name === nameInput)
    if(isValidated.length > 0) {
      if(isOnList) setSnackbar( "Ya tienes ese nombre en la lista", "danger" )
      else {
        if(nameInput !== name.name) {
          setNames(names.map(item => {
            if (item.id === name.id) return {...item, name: nameInput, isBad: false, options: isValidated[0].options, selectedClients: []}
            else return item
          }))
        }
        return;
      }
    } else {
      let coincidences = await getCustomersCoincidences(nameInput, idStation, setSnackbar);

      if (coincidences) {
        if (coincidences.length === 0) {
          setSnackbar( "No se encontraron coincidencias de usuarios", "warning" )
          return;
        } else {
          coincidences = coincidences.map(customer => {
            const address = customer?.address ? customer?.address : {}
            const calle = address?.street ? ` -c: ${address?.street}` : ''
            const colonia = address?.colony ? ` -col: ${address?.colony}` : ''
            const codigoPostal = address?.postalCode ? ` -cp: ${address?.postalCode}` : ''
            return {
              ...customer, 
              value: customer.id, 
              label: `${customer.name}${calle}${colonia}${codigoPostal}`
            }
          })

          setValidatedNames([...validatedNames, {name: nameInput, options: coincidences}])
          if(nameInput !== name.name) {
            setNames(names.map(item => {
              if (item.id === name.id) return {...item, name: nameInput, isBad: false, options: coincidences, selectedClients: []}
              else return item
            }))
          }
          return;
        }
      }
    }

    setNames(names.map(item => {
      if (item.id === name.id) return {...item, name: '', isBad: true, options: [], selectedClients: []}
      else return item
    })) 
  };

  useEffect(() => {
    if(name.name) {
      if(nameInput !== name.name) {
        setNames(names.map(item => {
          if (item.id === name.id) return {...item, name: '', isBad: true, options: [], selectedClients: []}
          else return item
        }))
      } 
    } else {
      if(nameInput.length > 2) {
        const isOnList = names.filter(item => item.name === nameInput && item.id !== name.id).length !== 0
        const isValidated = validatedNames.filter(vName => vName.name === nameInput)

        if (isValidated.length > 0 && !isOnList) {
          setNames(names.map(item => {
            if (item.id === name.id) return {...item, name: nameInput, isBad: false, options: isValidated[0].options, selectedClients: [] }
            else return item
          }))
        }
        if(isOnList) setSnackbar( "Ya tienes ese nombre en la lista", "danger" )
      }
    }
  }, [nameInput])
  
  return (
    <>
      <Box style={{width: '100%', display: 'flex', flexDirection: 'column'}}>
        <form style={{width: '100%'}} onSubmit={handleSearch}>
          <TextField
            label='Nombre de Grupo *'
            disabled={deleteMode}
            name="nameInput"
            value={nameInput}
            onChange={handleInputOnChange}
            variant="outlined"
            fullWidth
            error={name.isBad}
            InputProps={{
              endAdornment: (
                <>
                  <SearchIcon
                    onClick={handleSearch}
                    style={{ cursor: "pointer", margin: 0 }}
                  />
                  <CloseIcon
                    onClick={cleanForm}
                    style={{ cursor: "pointer", margin: 0 }}
                  />
                </>
              ),
            }}
            autoFocus={true}
          />
        </form>
        { name.options.length > 0 ? <FormCustomerSelectRuleEdit setNames={setNames} names={names} name={name}/> : null }
      </Box>
    </>
  )
})
